import Checkbox from "@mostrans/web-components/components/base/Checkbox";
import { Accordion, AccordionDetails, AccordionSummary, FormControlLabel } from "@mui/material";
import React, { useState } from "react";
import { useGetMasterDivision } from "../../shared/hooks/useGetMasterData";

const FilterKota = (props) => {
  const { classes, handleChange, filter } = props;
  const [listDivision] = useGetMasterDivision();
  const [active, setActive] = useState();

  const optionsDivisi = listDivision.map((item) => {
    return { value: item.id, label: item.division };
  });

  return (
    <Accordion
      className={classes.root}
      disableGutters={true}
      defaultExpanded={true}
      style={{ boxShadow: "none", borderRadius: "10px" }}>
      <AccordionSummary classes={{ content: classes.content }} onClick={() => setActive(!active)}>
        <b>Divisi</b>
        <div>
          {(() => {
            if (active) {
              return <span className="material-icons">expand_less</span>;
            } else {
              return <span className="material-icons">expand_more</span>;
            }
          })()}
        </div>
      </AccordionSummary>
      <AccordionDetails>
        {(() => {
          if (!!optionsDivisi) {
            return optionsDivisi.map((item) => (
              <FormControlLabel
                className="w-100"
                key={item.value}
                control={
                  <Checkbox
                    onChange={(e) => handleChange(e)}
                    name={item.label}
                    value={item.label}
                    // checked={filter.includes(item.label)}
                    checked={Object.values(filter).includes(item.label)}
                    sx={{ marginRight: "10px" }}
                  />
                }
                sx={{ textTransform: "capitalize" }}
                label={item.label}></FormControlLabel>
            ));
          } else {
            return null;
          }
        })()}
      </AccordionDetails>
    </Accordion>
  );
};

export default FilterKota;
